import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const rupiah = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n || 0);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

// Download a report (Excel/PDF) from the backend export endpoint.
export const exportReport = async (kind, fmt, { start, end, month, filename } = {}) => {
  const params = new URLSearchParams({ kind, fmt });
  if (start) params.set("start", start);
  if (end) params.set("end", end);
  if (month) params.set("month", month);
  const res = await fetch(`${API}/reports/export?${params.toString()}`, {
    credentials: "include",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (!res.ok) throw new Error("Gagal mengunduh");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename || "laporan_" + kind}.${fmt === "pdf" ? "pdf" : "xlsx"}`;
  a.click();
  URL.revokeObjectURL(url);
};

export default api;
